import axios, { type AxiosError } from "axios";

type ApiError = {
  message: string;
  code?: string;
  details?: Record<string, string[]>;
};

export const DEFAULT_MESSAGE = {
  ERROR: {
    MESSAGE: "Something went wrong!",
    SUB_MESSAGE: "Please try again later or contact support.",
  },
};

export function getErrorMessage(error: unknown) {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ApiError>;

    if (axiosError.response?.data?.message)
      console.error(axiosError.response?.data?.message);

    switch (axiosError.response?.status) {
      case 400:
        return "Invalid request. Please check your input.";
      case 401:
        return "You are not authorized. Please log in again.";
      case 403:
        return "You do not have permission to perform this action.";
      case 404:
        return "The requested resource was not found.";
      case 409:
        return "Conflict: This already exists. Try something different.";
      case 422:
        return axiosError.response.data?.message || "Validation failed.";
      case 429:
        return "Too many requests. Please try again later.";
      case 500:
        return "We're experiencing a temporary issue.";
      default:
        return `Request failed: ${axiosError.response?.status || "Unknown error"}`;
    }
  }

  // 2. Network errors
  if (error instanceof Error && !error.message.includes("fetch")) {
    if (error.message === "Network Error" || !navigator.onLine) {
      return "No internet connection. Please check your network.";
    }
  }

  // 3. Generic fallback
  return error instanceof Error
    ? error.message
    : "An unexpected error occurred.";
}
